import React, { useEffect } from 'react';
import { BrowserView } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { useTimer } from 'react-timer-hook';

import {
  AnimacaoAprender,
  AnimacaoDispositivos,
  AnimacaoEstudante,
} from 'Component/Animacao';
import BotaoLink from 'Component/BotaoLink';
import { CategoriaCartao } from 'Component/Categoria';
import Icone from 'Component/Icone';
import Plano from 'Interface/Planos';
import { useRecuperarCategoriasQuery, useRecuperarPlanosQuery } from 'Service';
import { useAppSelector } from 'Store';

const Default = (): React.ReactElement => {
  const navegacao = useNavigate();
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const limiteDeTempo = new Date();
  limiteDeTempo.setHours(23, 59, 59);

  const { seconds, minutes, hours } = useTimer({
    expiryTimestamp: limiteDeTempo,
    onExpire: () => console.warn('onExpire called'),
  });

  const { data: { planos: [plano] } = { planos: [{} as Plano] } } =
    useRecuperarPlanosQuery({ limit: 1 });
  const { data: { categorias } = {} } = useRecuperarCategoriasQuery({
    limit: 100,
  });

  useEffect(() => {
    if (usuario) {
      navegacao('/intro');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="animate__animated animate__fadeIn mh-100">
      <div
        className="container-fluid"
        style={{
          backgroundImage: 'url(/img/fundo-assinar.webp)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right',
          marginTop: '-130px',
        }}
      >
        <div
          className="row align-items-center justify-content-center pt-5"
          style={{ minHeight: window.innerHeight }}
        >
          <div className="col-md-6 text-center mt-5 mt-sm-0 pt-5">
            <h1 className="display-4 fw-lighter text-white text-center mt-4 text-white">
              Os melhores cursos{' '}
              <span className="display-1 d-block">em um só lugar</span>
            </h1>
            <p className="lead text-muted col-md-8 mx-auto">
              Experimente por{' '}
              <span className="text-primary">7 dias Grátis</span> e tenha acesso
              a todos os conteúdos. São mais de 1000 cursos em todas as áreas
              com certificado emitido por Faculdade com Nota Máxima no MEC. Não
              perca essa Oportunidade!
            </p>
            <BotaoLink
              lg
              to="/cadastrar"
              tema="secondary"
              className="mt-5 py-3 px-4"
            >
              Experimentar por 7 dias grátis
            </BotaoLink>
            <small className="d-block text-muted mt-1">
              Condição especial válida somente HOJE! <br />
              Promoção termina em
              <span className="text-secondary fw-bold ms-1">
                {hours.toString().padStart(2, '0')}:
                {minutes.toString().padStart(2, '0')}:
                {seconds.toString().padStart(2, '0')}
              </span>
            </small>
            <small className="d-block text-muted mt-3">
              Teste por <strong className="text-primary">7 dias</strong> de
              forma totalmente{' '}
              <strong className="text-primary">gratuita</strong>.
              <br />
              <span className="text-white">
                Após os 7 dias, você paga apenas{' '}
                <span className="text-secondary fw-bold">
                  {plano.valor?.moeda()}/mês
                </span>
                ,
              </span>
              <br />
              cobrado em seu cartão de crédito sem consumir seu limite.
              <br />
              Cancele quando quiser sem multa.
            </small>
            <a href="#saiba-mais" className="mt-5 d-block text-decoration-none">
              <Icone
                nome="chevron-double-down"
                className="text-secondary fs-1"
              />
              <span className="d-block text-white">Saiba mais</span>
            </a>
          </div>
          <BrowserView renderWithFragment>
            <div className="col-md-6">
              <AnimacaoAprender />
            </div>
          </BrowserView>
        </div>
      </div>
      <div id="saiba-mais"></div>
      <div className="container px-4 px-sm-0">
        <div className="row mh-100 justify-content-center mx-1 mx-sm-0">
          <div className="col-md-12 mb-5">
            <h1 className="display-4 fw-lighter text-white mt-5 text-center">
              Muito mais que streaming de cursos
            </h1>
            <p className="lead text-muted text-center mb-5">
              É uma nova opotunidade para você maximizar seu conhecimento e
              abrir novas oportunidades!
            </p>
          </div>
          <div className="col-6 col-md-3 mb-3">
            <div className="d-flex flex-column justify-content-center align-items-center border border-dark rounded-3 p-3">
              <Icone nome="view-list" className="display-1 text-muted" />
              <p className="display-1 text-secondary mb-0 fw-bold">20+</p>
              <p className="h3 fw-lighter text-muted text-center">
                Área de atuação
              </p>
            </div>
          </div>
          <div className="col-6 col-md-3 mb-3">
            <div className="d-flex flex-column justify-content-center align-items-center border border-dark rounded-3 p-3">
              <Icone nome="book" className="display-1 text-muted" />
              <p className="display-1 text-secondary mb-0 fw-bold">1000+</p>
              <p className="h3 fw-lighter text-muted text-center">
                Cursos disponíveis
              </p>
            </div>
          </div>
          <div className="col-6 col-md-3 mb-3">
            <div className="d-flex flex-column justify-content-center align-items-center border border-dark rounded-3 p-3">
              <Icone nome="collection-play" className="display-1 text-muted" />
              <p className="display-1 text-secondary mb-0 fw-bold">10k+</p>
              <p className="h3 fw-lighter text-muted text-center">
                Aulas para assistir
              </p>
            </div>
          </div>
          <div className="col-6 col-md-3 mb-3">
            <div className="d-flex flex-column justify-content-center align-items-center border border-dark rounded-3 p-3">
              <Icone nome="people-fill" className="display-1 text-muted" />
              <p className="display-1 text-secondary mb-0 fw-bold">300k+</p>
              <p className="h3 fw-lighter text-muted text-center">
                Alunos inscritos
              </p>
            </div>
          </div>
          <div className="col-md-6 mt-5 d-flex flex-column justify-content-center align-items-center mb-5">
            <p className="lead text-muted mb-5 text-center">
              O Estude+ nasceu da experiência de muitos anos adquirida pela
              Faculdade Metropolitana do Estado de São Paulo com o Estude Sem
              Fronteiras, um dos maiores portais de cursos on-line do Brasil. Em
              todos esses anos, foram mais de 300 mil alunos matriculados!
            </p>
            <BotaoLink lg to="/cadastrar" tema="primary" className="py-3 px-4">
              <React.Fragment>Experimentar por 7 dias grátis</React.Fragment>
            </BotaoLink>
            <small className="d-block text-muted text-center">
              Condição especial válida somente HOJE! <br />
              Promoção termina em
              <span className="text-secondary fw-bold ms-1">
                {hours.toString().padStart(2, '0')}:
                {minutes.toString().padStart(2, '0')}:
                {seconds.toString().padStart(2, '0')}
              </span>
            </small>
          </div>
        </div>
      </div>

      <div className="container my-5 py-5 px-4 px-sm-0">
        <div className="row mh-100 align-items-center mx-1 mx-sm-0">
          <div className="col-md-6 order-2 order-sm-2">
            <h2 className="display-4 mb-4 fw-lighter text-white text-center text-sm-end">
              Estude do seu jeito
            </h2>
            <p className="lead text-muted text-center text-sm-end">
              Você pode assistir aos cursos do Estude+ pelo seu computador,
              notebook, tablet ou celular! Seja em uma mesa do seu escritório,
              no ônibus ou no conforto de um sofá, trabalhamos a interface para
              maximizar a sua experiência durante seus estudos!
            </p>
            <div className="mt-5 text-center text-sm-end">
              <BotaoLink
                lg
                to="/cadastrar"
                tema="secondary"
                className="py-3 px-4"
              >
                <React.Fragment>Experimentar por 7 dias grátis</React.Fragment>
              </BotaoLink>
              <small className="d-block text-muted">
                Condição especial válida somente HOJE! <br />
                Promoção termina em
                <span className="text-secondary fw-bold ms-1">
                  {hours.toString().padStart(2, '0')}:
                  {minutes.toString().padStart(2, '0')}:
                  {seconds.toString().padStart(2, '0')}
                </span>
              </small>
            </div>
          </div>
          <div className="col-md-6 order-1 order-sm-2 p-5">
            <AnimacaoDispositivos />
          </div>
        </div>
      </div>

      <div className="container my-5 py-5 px-4 px-sm-0">
        <div className="row mh-100 align-items-center mx-1 mx-sm-0">
          <div className="col-md-6">
            <AnimacaoEstudante />
          </div>
          <div className="col-md-6">
            <h2 className="display-4 mb-4 fw-lighter text-white text-center text-sm-start">
              Como funciona
            </h2>
            <p className="lead text-muted text-center text-sm-start">
              Imediatamente após concluir sua assinatura, você já pode acessar e
              assistir a qualquer uma das aulas de todos os mais de 1000 cursos
              disponíveis no Estude+
            </p>
            <p className="lead text-muted text-center text-sm-start">
              Ao concluir todas as aulas de um curso, você poderá realizar a
              avaliação para obtenção de certificado emitido pela Faculdade
              Metropolitana do Estado de São Paulo – Nota Máxima no MEC.
            </p>
            <p className="lead text-muted text-center text-sm-start">
              O certificado em formato digital é disponibilizado sem qualquer
              custo adicional. Se quiser uma via impressa pelos correios, é
              cobrada apenas uma taxa de emissão e envio.
            </p>
            <div className="mt-5">
              <BotaoLink
                lg
                to="/cadastrar"
                tema="secondary"
                className="py-3 px-4"
              >
                <React.Fragment>Experimentar por 7 dias grátis</React.Fragment>
              </BotaoLink>
              <small className="d-block text-muted text-center text-sm-start">
                Condição especial válida somente HOJE! <br />
                Promoção termina em
                <span className="text-secondary fw-bold ms-1">
                  {hours.toString().padStart(2, '0')}:
                  {minutes.toString().padStart(2, '0')}:
                  {seconds.toString().padStart(2, '0')}
                </span>
              </small>
            </div>
          </div>
        </div>
      </div>

      <div className="container my-5 py-5">
        <div className="row align-items-center justify-content-center px-3 px-sm-0">
          <div className="col-md-12 mb-5">
            <h2 className="display-4 fw-lighter text-center text-white">
              Cursos que você encontra no Estude+
            </h2>
            <p className="lead text-center text-muted">
              E não para por ai! Estamos adicionando cursos novos a cada dia!
            </p>
          </div>
          {categorias?.map((categoria) => (
            <div
              key={`${categoria.id}-${categoria.modificado}`}
              className="col-md-3 mb-3"
            >
              <CategoriaCartao dados={categoria} />
            </div>
          ))}
          <div className="mt-5 text-center">
            <BotaoLink lg to="/cadastrar" tema="primary" className="py-3 px-4">
              <React.Fragment>Experimentar por 7 dias grátis</React.Fragment>
            </BotaoLink>
            <small className="d-block text-muted">
              Condição especial válida somente HOJE! <br />
              Promoção termina em
              <span className="text-secondary fw-bold ms-1">
                {hours.toString().padStart(2, '0')}:
                {minutes.toString().padStart(2, '0')}:
                {seconds.toString().padStart(2, '0')}
              </span>
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Default;
